/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UnlockIcon = /*#__PURE__*/ createSvgIcon(
  'UnlockIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.5 16.5h9v-8h-9v8zm4.504-2.5c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 009.996 11c-.414 0-.767.147-1.059.442a1.456 1.456 0 00-.437 1.062c0 .414.147.767.442 1.059.294.291.649.437 1.062.437zm-4.51 4c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 16.5v-8c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44H11V5c0-1.107.39-2.05 1.17-2.83C12.95 1.39 13.893 1 15 1c1 0 1.854.299 2.563.896a3.958 3.958 0 011.354 2.25c.041.194-.01.385-.152.573-.142.187-.313.281-.511.281a.85.85 0 01-.525-.156.82.82 0 01-.291-.448 2.505 2.505 0 00-.878-1.354A2.405 2.405 0 0015 2.5a2.41 2.41 0 00-1.77.73A2.411 2.411 0 0012.5 5v2h2c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v8c0 .413-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UnlockIcon;
